const Flight = (state) => state.Flight
const flightLegs = (state) => state.flightLegs

export default {
  Flight,
  flightLegs
}
